import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComplianceComponent } from './list-compliance/list-compliance.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';

const routes: Routes = [
  {
    path: '',
    component: ListComplianceComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-and-condition',
    component: TermsAndConditionComponent,
  },
  
  { path: '', pathMatch: 'full', redirectTo: 'catalog/compliance' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplianceRoutingModule { }
